import { DialogButton } from '@beeinventor/dasiot-react-component-lib';
import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogProps as MuiDialogProps,
  styled,
} from '@mui/material';

const Dialog = styled(MuiDialog)`
  & .MuiPaper-root {
    width: 480px;
    & .title {
      font-size: 1.75rem;
      line-height: 1.5;
      text-align: center;
      font-weight: 700;
      color: ${({ theme }) => theme.color.secondary.$120};
      margin: 24px 24px 0;
    }

    & .email {
      text-align: center;
      font-size: 0.875rem;
      line-height: 1.5;
      color: ${({ theme }) => theme.color.secondary.$80};
      margin-top: 4px;
    }

    & .error-container {
      text-align: center;
      padding: 8px;
      color: ${({ theme }) => theme.color.highlight};
    }
  }
`;

const DialogContent = styled(MuiDialogContent)`
  text-align: center;
  margin: 0 auto;
  padding: 0;
`;

const DialogActions = styled(MuiDialogActions)`
  justify-content: space-between;
  padding: 24px;
`;

interface MeErrorDialogProps extends MuiDialogProps {
  email?: string;
  errorMessage?: string;
  onLogout: () => void;
  onRefresh: () => void;
}

const MeErrorDialog: React.FC<MeErrorDialogProps> = ({
  email,
  errorMessage,
  onLogout,
  onRefresh,
  ...otherProps
}) => {
  return (
    <Dialog {...otherProps}>
      <div className="title">Failed to load user info</div>
      <DialogContent>
        {email && <div className="email">{email}</div>}
        {errorMessage && <div className="error-container">{errorMessage}</div>}
      </DialogContent>
      <DialogActions>
        <DialogButton
          mode="light"
          variant="text"
          color="secondary"
          onClick={onLogout}
        >
          Logout
        </DialogButton>
        <DialogButton variant="contained" color="primary" onClick={onRefresh}>
          Refresh
        </DialogButton>
      </DialogActions>
    </Dialog>
  );
};

export default MeErrorDialog;
